import { imageUrl } from "config";

export const generateUrl = (publicId: string) => {
  //return "/images/test.jpeg";
  const finalUrl = [imageUrl, publicId].join("/");
  return finalUrl;
};

export const generateThumbnailUrl = (publicId: string) => {
  //return generateUrl(publicId);
  const finalUrl = [imageUrl, publicId.replace(".", "_thumbnail.")].join("/");
  return finalUrl;
};
